export const masterConf = {
    tableInfo: {
        type: 'dataTable',
        title: {
            display: true,
            text: '',
            align: 'center',    //where to align the element within div i.e left, center or right
            order: 'order-md-2' //Order of the element from left. defined in DataTableModule.toolBarElementOrder
        },
    },
    css: {
        tableClass: 'table table-striped',
        // theadClass: 'thead-dark text-center'
    },
    sortOptions: {
        sortIndex: 0,
        sortType: 'asc'
    },
    downloadButton: {
        display: true,
        text:'Download',
        align:'right',       //where to align the element within div i.e left, center or right
        order: 'order-md-3'  //Order of the element from left. defined in DataTableModule.toolBarElementOrder
    },
    searchFilter: {
        display: false,
        align: 'left',       //where to align the element within div i.e left, center or right
        order: 'order-md-1'  //Order of the element from left. defined in DataTableModule.toolBarElementOrder
    },
    downloadOptions: [
        {
            downloadType: 'xlsx',
            downloadFileName: 'rainfall',
            downloadAll: true,  //pass false if only current page data is to be downloaded
            metaData: false //pass true if meta data needs to be added in excel (Option only for excel and all data needs to be downloaded)
        }
    ],
    paginatorOptions: {
        limit: 15,
        maxSize: 5,     // Max pages to display on the link
        visible: true,
        // directionLinks: 'false',
        // autoHide: 'false',
        // previousLabel: 'prev',
        // nextLabel: 'nex',
        dropdownOptions: [{
            value: 5,
            display: '5'
        },
        {
            value: 10,
            display: '10'
        },
        {
            value: 15,
            display: '15'
        },
        {
            value: 20,
            display: '20'
        },
        {
            value: 25,
            display: '25'
        },
        {
            value: -1,
            display: 'All'
        }]
    },
    tableHeaderFixerInfo: {
        headerFix: true,
        colFix: true,
        rowFix: false,	 	//If we want to fix the data rows as well.
        noOfCol: 2,
        noOfRow: 1		//no of data rows from top that needs to be fixed
    },
    totalRow: {
        position: 'top',    //top, bottom
        displayAs: '',      //Custom text to display, default 'Total'
        name: 'total',
        jsonKey: '-1',
        colspan: 2          //How many columns should it span to, this will start from the far left so add +1 to make up for S.No column
    },
    indexCons: {
        show: true,
        class: 'tc-bg-01'
    },
    columns: [
        {
            jsonKey: {
                path: 'entityName',
                type: 'LOCATION'
            },
            name: "Location",
            dataType: 'LOCATION',
            defaultValue: '-',
            // sortOrderList : ['SRIKAKULAM', 'VIZIANAGARAM', 'VISAKHAPATNAM', 'EAST GODAVARI', 'WEST GODAVARI', 'KRISHNA', 'GUNTUR', 'PRAKASAM', 'NELLORE', 'CHITTOOR', 'KADAPA', 'Y.S.R KADAPA', 'ANANTHAPUR', 'ANANTAPUR', 'KURNOOL']
        },
        {
            name: 'Student ID',
            jsonKey: {
                path: 'stuId'
            },
            dataType: 'TEXT',
            defaultValue: '-',
            class: 'tc-bg-03'
        },
        {
            name: 'Student Name',
            jsonKey: {
                path: 'stuName'
            },
            dataType: 'POPUP',
            defaultValue: '-',
            class: 'tc-bg-04',
            popupInfo: {
                component: 'modalDemo'
            }
        },
        {
            name: 'Marks',
            class: 'tc-bg-05',
            childs: [
                {
                    name: 'Sub 1',
                    jsonKey: {
                        path: 'marks.sub1.val##marks.sub1.perc'
                    },
                    dataType: 'NUMBER##PERCENTAGE',
                    defaultValue: '-',
                    class: 'tc-bg-05'
                },
                {
                    name: 'Sub 2',
                    jsonKey: {
                        path: 'marks.sub2.val##marks.sub2.perc'
                    },
                    dataType: 'NUMBER##PERCENTAGE',
                    defaultValue: '-',
                    class: 'tc-bg-05'
                },
                {
                    name: 'Sub 3',
                    jsonKey: {
                        path: 'marks.sub3.val##marks.sub3.perc'
                    },
                    dataType: 'NUMBER##PERCENTAGE',
                    defaultValue: '-',
                    class: 'tc-bg-05'
                },
            ]
        },
        {
            name: 'Attendance',
            class: 'tc-bg-06',
            childs: [
                {
                    name: 'Jan',
                    jsonKey: {
                        path: 'attd.jan'
                    },
                    dataType: 'PERCENTAGE',
                    defaultValue: '-',
                    class: 'tc-bg-06'
                },
                {
                    name: 'Feb',
                    jsonKey: {
                        path: 'attd.feb'
                    },
                    dataType: 'PERCENTAGE',
                    defaultValue: '-',
                    class: 'tc-bg-06'
                },
                {
                    name: 'March',
                    jsonKey: {
                        path: 'attd.mar'
                    },
                    dataType: 'PERCENTAGE',
                    defaultValue: '-',
                    class: 'tc-bg-06'
                },
            ]
        },
    ]
}
